import Reel from "./Reel";

export default class ReelPrinter {

    private posX: Array<number>;
    private posY: Array<number>;
    private offsetY: number;

    constructor (x: Array<number>, y: Array<number>, symbolHeight: number, shiftY: number) {
        this.posX = x; //gameset.game.symbolModel.matrix.x;
        this.posY = y; //gameset.game.symbolModel.matrix.y;

        this.offsetY = symbolHeight + shiftY; //gameset.game.symbolModel.symbolSize.height + gameset.game.symbolModel.matrix.shiftY;
    }

    print (reel: Reel, shift: number = 0) {

        // let id = slotReel.getId();

        let symbols = reel.getSymbols();
        let i = reel.id;

        for(let j = 0, l = symbols.length; j < l; j++) {

            symbols[j].x = this.posX[i];

            if(j > 0) {
                symbols[j].y = this.posY[i] + (this.offsetY * (j - 1));
            } else {
                symbols[j].y = this.posY[i] - this.offsetY;
            }


            // if(id === 0) {
            //     console.log(shift);
            // }
            symbols[j].y += shift;

            // if(j > 0 && j < l - 1) {
            //     symbols[j].y = this.posY[0] + (this.shiftY * j);
            //     //symbols[j].visible = false;
            // } else {

            //     if(j === 0) {
            //         symbols[j].y = this.posY[0] - this.shiftY;
            //         continue;
            //     }

            //     if(j === l - 1) {
            //         symbols[j].y = this.posY[2] + this.shiftY;
            //         //console.log(j, symbols[j].y, this.posY[2] - this.posY[1]);
            //     }

            // }

            //console.log(symbols[j].x, symbols[j].y);
        }
    }

}
